<template>
  <Layout
    :errors="errors"
    :title="trans(`models.settings.content.edit.action`)"
    :toasts="toasts"
    :resource="model"
  >
    <template #top>
      <resource-action-header
        :model="model"
        :action="'edit'"
        :description="model.data.attributes.description"
      ></resource-action-header>
    </template>
    <ul class="nav nav-tabs gap-1" style="margin: 0 0 -1px 0.5rem">
      <li class="nav-item">
        <Link
          :href="route(`${routePrefix}.modules.edit`, { id: $page.props.module.data.id })"
          :class="model.data.id === $page.props.module.data.id ? 'active' : 'text-muted'"
          class="nav-link"
        >
          {{ $page.props.module.data.attributes.name }}
        </Link>
      </li>
      <feature-tabs :features="$page.props.features" :selected-feature="model"></feature-tabs>
    </ul>
    <div v-if="model.data && focus === 'self'" class="card rounded-corner">
      <div class="card-body">
        <div class="row g-3 mb-2 mt-0">
          <div v-if="model" class="col-12 mt-0">
            <h3>{{ model.data.attributes.name }}</h3>
            <settings-form :settings="model.data.collections.settings" :parent-model="model"></settings-form>
          </div>
        </div>
      </div>
    </div>
    <template #right>
      <admin-sidebox :resource="model"></admin-sidebox>
    </template>
  </Layout>
</template>

<script>
import Card from '@kanrisha/components/Base/Card';
import Layout from '@kanrisha/Pages/Layout';
import ResourceForm from '@kanrisha/components/ResourceForm';
import ResourceActionButtons from '@kanrisha/components/Links/ResourceActionButtons';
import ResourceCollection from '@kanrisha/components/ResourceCollection';
import ResourceSelection from '@kanrisha/components/ResourceSelection';
import useModels from '@kanrisha/composables/useModels';
import { ref } from 'vue';
import { Link, router } from '@inertiajs/vue3';
import useResource from '@kanrisha/composables/useResource';
import useToasts from '@kanrisha/composables/useToasts';
import AdminSidebox from '@kanrisha/components/Layout/AdminSidebox';
import PickedResourceCard from '@kanrisha/components/Cards/PickedResource';
import RelationCollectionCard from '@kanrisha/components/Cards/RelationCollection';
import ResourceActionHeader from '@kanrisha/components/Layout/ResourceActionHeader';
import FormField from "@kanrisha/components/Form/FormField";
import ColoredIcon from "@kanrisha/components/Icons/ColoredIcon";
import RelationLink from "@kanrisha/components/Elements/Display/RelationLink";
import FeatureTabs from '@/aspects/admin/components/Feature/FeatureTabs';
import SettingsForm from "@/aspects/admin/components/Setting/SettingsForm";

export default {
  components: {
    SettingsForm,
    FeatureTabs,
    RelationLink,
    ColoredIcon,
    FormField,
    AdminSidebox,
    Card,
    Layout,
    Link,
    PickedResourceCard,
    RelationCollectionCard,
    ResourceActionButtons,
    ResourceActionHeader,
    ResourceCollection,
    ResourceForm,
    ResourceSelection,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    settings: { type: Object, default: () => {} },
    logEntries: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  emits: ['update:toast'],
  setup(props) {
    const { meta, resourceType } = useResource(props, props.model);
    const { addToasts } = useToasts(props);
    const focus = ref(props.model.meta.adjustments.focus ?? 'self');
    const settings = ref(props.model.data.collections.settings);

    const setFocus = (name) => {
      const { focus: setFocusAdjustment } = useModels({ resourceType: 'settings' });
      setFocusAdjustment(props.model.meta.resourceType, name);
      focus.value = name;
    };


    const saveSetting = (setting) => {
      let { storeModel } = useModels({ resourceType: 'settings' });
      storeModel(setting, 'settings');
    }

    const updateMedia = (setting, mediaItems) => {
      setting.media = mediaItems;
      setting.data.attributes.media_ids = mediaItems.filter((item) => !item.remove).map((item) => item.id);
      setting.data.attributes.remove_media_ids = mediaItems
        .filter((item) => item.remove)
        .map((item) => item.id);
    };

    return {
      addToasts,
      focus,
      meta,
      resourceType,
      saveSetting,
      setFocus,
      settings,
      updateMedia,
    };
  },
};
</script>

<style type="text/css">
  .media-container {
    max-width: 100%;
  }
</style>